/**
 * Frontend mirror of backend utils/weeklyOff.js — Sundays + Saturday policy + holidays.
 * Keep in sync with HRMS-PORTAL-Backend/utils/weeklyOff.js.
 */

export const DEFAULT_SATURDAY_POLICY = "1_3_5";

export const SATURDAY_POLICIES = {
  working: "Every Saturday working",
  all_off: "All Saturdays off",
  "1_3": "1st & 3rd Saturday off",
  "2_4": "2nd & 4th Saturday off",
  "1_3_5": "1st, 3rd & 5th Saturday off (2nd & 4th working)",
};

export function nthOfMonth(dayOfMonth) {
  return Math.ceil(Number(dayOfMonth) / 7);
}

export function isSaturdayOffByDay(dayOfMonth, policy = DEFAULT_SATURDAY_POLICY) {
  const nth = nthOfMonth(dayOfMonth);
  switch (policy) {
    case "all_off": return true;
    case "1_3": return nth === 1 || nth === 3;
    case "2_4": return nth === 2 || nth === 4;
    case "1_3_5": return nth === 1 || nth === 3 || nth === 5;
    case "working": return false;
    default: return nth === 1 || nth === 3 || nth === 5;
  }
}

export function isSunday(date) {
  return date instanceof Date && date.getDay() === 0;
}

export function isSaturday(date) {
  return date instanceof Date && date.getDay() === 6;
}

export function isSaturdayOff(date, policy = DEFAULT_SATURDAY_POLICY) {
  if (!isSaturday(date)) return false;
  return isSaturdayOffByDay(date.getDate(), policy);
}

/** Sunday or policy Saturday (not holidays — pass holiday map separately). */
export function isWeeklyOff(date, policy = DEFAULT_SATURDAY_POLICY) {
  return isSunday(date) || isSaturdayOff(date, policy);
}

export function localDateKey(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function isoDateKey(date) {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** True for Sunday, 1st/3rd/5th (etc.) Saturday, or a holiday key in the map/set. */
export function isCompanyOffDay(date, { saturdayPolicy = DEFAULT_SATURDAY_POLICY, holidayByKey } = {}) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return false;
  if (holidayByKey) {
    const k1 = localDateKey(date);
    const k2 = isoDateKey(date);
    if (holidayByKey[k1] || holidayByKey[k2] || (holidayByKey instanceof Set && (holidayByKey.has(k1) || holidayByKey.has(k2)))) {
      return true;
    }
  }
  return isWeeklyOff(date, saturdayPolicy);
}
